(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('ProblemList', ProblemList);

    ProblemList.$inject = ['$resource', 'DateUtils'];

    function ProblemList ($resource, DateUtils) {
        var resourceUrl =  'api/problem-lists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/problem-list-by-patient/:id', method: 'GET', isArray: true},
            'getAllActiveByPatientId': { 'url': 'api/active-problem-list-by-patient/:id', method: 'GET', isArray: true},
        });
    }
})();
